"use client";

import { Button } from "~care/components/ui/Button/Button";

export default function CookiePreferencesButton() {
  return (
    <Button
      className="h-fit w-fit p-0 font-medium text-sm underline hover:no-underline"
      onClick={() =>
        window?.Osano?.cm?.showDrawer("osano-cm-dom-info-dialog-open")
      }
      variant="plain"
    >
      Cookie Preferences
    </Button>
  );
}
